<template>
  <transition
    name="goTopButton"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
  >
  <div class="fixed-oval-icon duration" :style="{ bottom : (isHomeShoppingChannel ? '55px' : '15px') }" @click.prevent="goTop" v-if="showGoTop">
    <OvalIcon />
  </div>
  </transition>
</template>

<script>
import OvalIcon from '@/assets/svg/common/oval.svg'
export default {
  name: 'Oval',
  props: {
    isHomeShoppingChannel: {
      type: Boolean
    },
  },
  components: { OvalIcon },
  data () {
    return {
      showGoTop: false,
      isScrolling: null
    }
  },
  methods: {
    goTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    handleScrollFn () {
      window.clearTimeout(this.isScrolling)
      this.showGoTop = false
      this.isScrolling = setTimeout(() => {
        let offsetY = document.body.scrollTop || document.documentElement.scrollTop
        this.showGoTop = offsetY > 0
      }, 200)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScrollFn)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScrollFn)
  }
}
</script>
<style scoped>
 .fixed-oval-icon {
   position: fixed;
   right: 15px;
   bottom: 15px;
   width: 50px;
   height: 50px;
   border-radius: 50%;
   box-shadow: 10px 10px 10px 0 rgba(0,0,0,.3);
   z-index:5001;
 }
 .fixed-oval-icon.duration {
   animation-duration: 100ms;
 }
</style>
